import { Button, Form, Input, Modal } from "antd";
import React, { useState, useCallback, useEffect } from "react";
import AccountService from "../../../services/accounts.service";
import { allowOnlyAlphaNumericsWithSpace, allowOnlyAlphaNumericsShouldNotStartWithSpace } from "../../../services/common.service";
import { ReactComponent as TickIcon } from "../../../assests/images/tickIcon.svg";
import { useTranslation } from "react-i18next";
import { API_CONFIG } from "../../../services/constants/constant";
import { CONFIG } from "../../../environment";
export default function ModifyAccountNickName({
  selectedDetails = {},
  setVisible,
  setRefresh,
}) {
  const [form] = Form.useForm();
  const [visibleSuccess, setVisibleSuccess] = useState(false);
  const [message, setMessage] = useState("");
  const { t } = useTranslation();
  // useEffect(() => {
  //   if (Object.keys(selectedDetails).length > 0) {
  //     nickNameForm.setFieldsValue({
  //       accShortName: selectedDetails.acctShortName,
  //     });
  //   }
  // }, [selectedDetails]);

  const onFinish = useCallback(
    async (values) => {
      try {
        setVisible(false);
        const response = await AccountService.editAccShortName({
          accountNo: selectedDetails?.accountNo,
          accShortName: values?.accShortName,
        });
        if (response.status === 200) {
          setVisibleSuccess(true);
          setMessage(response.data["message"]);
        }
      } catch (error) {}
    },
    [selectedDetails]
  );

  function renderForm() {
    return (
      <>
        <Form form={form} layout="vertical" onFinish={onFinish}>
          <div>
            <Form.Item
              label={t("pages.my_accounts.casa.nickname", {
                defaultValue: "Nick Name",
              })}
              name="accShortName"
              rules={[
                {
                  required: true,
                  message: t("pages.Add_Bene.nick_name_required", {
                    defaultValue: "Nick Name is required",
                  }),
                },
              ]}
            >
              <Input
                size="large"
                onKeyPress={(e) => allowOnlyAlphaNumericsShouldNotStartWithSpace(e)}
                maxLength={CONFIG.BENE_NICKNAME_LENGTH}
                placeholder={t("pages.my_accounts.casa.nickname", {
                  defaultValue: "Nick Name",
                })}
              />
            </Form.Item>
          </div>
          <div align="right" className="mt-5">
            <Button
              type="default"
              size="large"
              className="secondary-btn mx-3"
              onClick={() => setVisible(false)}
            >
              {t("buttons.cancel_btn", {
                defaultValue: "Cancel",
              })}
            </Button>
            <Button type="primary" size="large" htmlType="submit">
              {t("buttons.save_btn", {
                defaultValue: "Save",
              })}
            </Button>
          </div>
        </Form>
      </>
    );
  }

  return (
    <>
      <div style={{ margin: "10px 20px" }}>{renderForm()}</div>

      <Modal
        open={visibleSuccess}
        footer={null}
        width={480}
        closable={false}
        maskClosable={false}
        mask={true}
        className="custom-error-modal"
      >
        <div style={{ margin: "0 auto" }} align="center">
          <TickIcon height={65} />
          <h4 className="mb-3 mt-2">
            {" "}
            {t("common.success", {
              defaultValue: "Success",
            })}
          </h4>
          <p>{message}</p>

          <div align="center">
            <Button
              size="large"
              style={{ width: 100 }}
              onClick={() => {
                setVisibleSuccess(false);
                setRefresh(true);
              }}
              type="primary"
            >
              {t("buttons.okay_btn", {
                defaultValue: "Okay",
              })}
            </Button>
          </div>
        </div>
      </Modal>
    </>
  );
}
